"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletionDetail = void 0;
const base_model_1 = require("../../base-model");
const completion_detail_schema_1 = require("./completion-detail.schema");
class CompletionDetail extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {
            missionDelay: {
                ops: false,
                mx: false,
                wxr: false,
                remarks: '',
            },
            missionCancel: {
                ops: false,
                mx: false,
                wxr: false,
                remarks: '',
            },
            airAbort: {
                ops: false,
                mx: false,
                wxr: false,
                remarks: '',
            },
        };
    }
    getSchema() {
        return completion_detail_schema_1.completionDetailSchema;
    }
}
exports.CompletionDetail = CompletionDetail;
